import styled from '@emotion/styled';
import React from 'react';
import { Button, IconLetter } from "@kompare/kompare-ui-library";
import { mediaQuery } from 'src/common';
import { Card, Flex, Text } from 'src/components';
import { colors, footer, header } from 'src/theme';
import config from 'src/config';

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const TextStyle = styled(Text)({
  maxWidth: 276,
  textAlign: 'center',
});

const ButtonStyle = styled(Button)({
  width: 'fit-content',
});

const MboThankYouPage = () => {
  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };
  
  return (
    <FlexStyle justify="center" align="center">
      <Card padding={24}>
        <Flex vertical gap={24} align='center'>
          <Flex vertical align="center" gap={8}>
            <IconLetter color={colors.icon4} />
            <Text type="large" bold>
              Hvala ti!
            </Text>
            <TextStyle type="base">Sve je spremno za izradu police koja uskoro stiže na tvoj email!</TextStyle>
          </Flex>
          <ButtonStyle btnType="outlinePrimary" onClick={navigateToHome}>Provjeri sve naše usluge</ButtonStyle>
        </Flex>
      </Card>
    </FlexStyle>
  );
};

export default MboThankYouPage;
